import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomerService } from "../../../../services/customer.service";
import { MemberService } from "../../../../app/main/apps/member/member.service";

import Swal from "sweetalert2";
import { cloneDeep } from "lodash";

@Component({
  selector: "app-payment-method",
  templateUrl: "./payment-method.component.html",
  styleUrls: ["./payment-method.component.scss"],
})
export class PaymentMethodComponent implements OnInit {
  @Input() paymentMethod: any;
  @Input() customer: any;

  @ViewChild("modalEditPaymentMethod", { static: true })
    modalEditPaymentMethod: any;

  public loading: boolean;
  public currentPaymentMethod;
  public paymentMethodIndex = 0;
  public loadingbtn = false;

  constructor(private _customerService: CustomerService, private modalService: NgbModal,) {}

  filterStatus(list: any[]): any[] {
    return list.filter(
      (p) =>
        p.status == "active" || p.status == "suspended" || p.status == "paused"
    );
  }

  addNewPaymentMethod(customerId) {
    this.loading = true;
    var link = window.location.href.split("?");
    var return_link = link[0] + "?active=8";

    this._customerService.addNewPaymentMethod(customerId, return_link, return_link).then(
      (data) => {
        if (data["url"] == null) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: data["description"],
            showConfirmButton: true,
            allowOutsideClick: function () {
              return !Swal.isLoading();
            },
          });
        } else {
          window.open(data["url"], "_self");
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  editPaymentMethod(paymentmethod_id) {
      this.paymentMethodIndex = this.paymentMethod.findIndex(
        (p) => p.id === paymentmethod_id
      );
      this.currentPaymentMethod = cloneDeep(
        this.paymentMethod[this.paymentMethodIndex]
      );
      this.modalService.open(this.modalEditPaymentMethod, {
        centered: true,
        size: "sm",
      });
    }
  
    sendEditPaymentMethod() {
      this.loadingbtn = true;
  
      if (this.currentPaymentMethod.hasActiveStatus == true) {
        this.currentPaymentMethod.status = "active";
      } else {
        this.currentPaymentMethod.status = "paused";
        this.currentPaymentMethod.primary_method = false;
      }
  
      var data = {
        status: this.currentPaymentMethod.status,
        primary_method: this.currentPaymentMethod.primary_method,
        description: this.currentPaymentMethod.description,
      };
  
      this._customerService
        .editPaymentMethod(this.currentPaymentMethod.id, data)
        .then(
          (data) => {                        
            this._customerService.getStatement().then((data:any) => {
              this.paymentMethod = data.paymentMethod;
              this.paymentMethod.forEach(element => {
                element['hasActiveStatus'] = (element.status == 'active');
              });        
              this.loadingbtn = false;
              this.modalService.dismissAll();
            });
  
          
          },
          (error) => {
            this.loadingbtn = false;
          }
        );
    }

    deletePaymentMethod(paymentmethod_id) {
        this._customerService.inactivatePaymentMethod(paymentmethod_id).then(
          (data) => {
            if (data["status"] != 'inactive') {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Your request could not be processed, try again or contact support",
                showConfirmButton: true,
                allowOutsideClick: function () {
                  return !Swal.isLoading();
                },
              });
            } else {
              Swal.fire({
                title: "Done!",
                html:
                  "<div><p>Your request was confirmed.</p></div>",
                  icon: "success",
                allowOutsideClick: true,
                showConfirmButton: true,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-secundary ml-1",
                },
              }).then(()=> {
                this._customerService.getStatement().then((data:any) => {
                  this.paymentMethod = data.paymentMethod;
                  this.paymentMethod.forEach(element => {
                    element['hasActiveStatus'] = (element.status == 'active');
                  });        
                
                  this.loadingbtn = false;
                  this.modalService.dismissAll();
                });
              });
            }
          },
          (error) => {
            this.loading = false;
          }
        );
      }

  /***
   *Question Before Open
   *
   */
  questionBeforeDeletePaymentMethod(paymentmethod) {
    Swal.fire({
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      icon: "warning",
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-secundary ml-1",
      },
      title: "",
      text: "Do you want to delete this Payment Method?",
      showConfirmButton: true,
      allowOutsideClick: function () {
        return !Swal.isLoading();
      },
    }).then(function (result) {
      if (result.value) {
        var procedure = <HTMLInputElement>(
          document.getElementById("deletePaymentMethod" + paymentmethod.id)
        );
        procedure.click();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  ngOnInit(): void {    
    this.paymentMethod.forEach(element => {
      element['hasActiveStatus'] = (element.status == 'active');
    });        
    
  }
}


